import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import top from '../Assets/tv-top.svg';
import bottom from '../Assets/tv-bottom.svg';
// import thum from '../Assets/tham.jpg';
import graduate from "../Assets/parant.svg"
import man from "../Assets/illustration-people-2.svg";
// import  communty from "../Assets/communty.png" 
import snail from "../Assets/snail.svg";
import thum1 from '../Assets/thum1.jpg';
// import thum2 from '../Assets/thum2.jpg';
import fox from "../Assets/fox-color.svg"
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';
import { Helmet } from "react-helmet";

const AboutUs = () => {
    const videoLinks = [
        { thumbnail: thum1, link: 'https://youtu.be/7eIAu6siRxw?si=_Ts3mRFjKKO0bTvy' },
    ];
    return (
        <ParallaxProvider>
            <Helmet>
                <title>Best Montessori Pre School Vellore | Kids Play School Near Me</title>
                <meta
                    name="description"
                    content="Leading Montessori Preschool & Kindergarten Play School in Vellore for Kids Under 6 Years, Offering a Safe, Nurturing Environment with Holistic Early Education."
                />
            </Helmet>


            <div className="">
                <div className='bg-[#f4f1ea] h-80 w-full'>
                    <div className="flex flex-col md:flex-row justify-between h-full pt-10 md:pt-20 pl-5 md:pl-28">
                        <div className='w-full   md:w-[30%] mt-8'>
                            <h1 className='text-[#0a3039]   text-[30px1]  md:text-[60px] font-bold navbar-link'>About</h1>
                            <p className='text-[#0a3039] md:text-lg  font-medium navbar-link'>
                                We help children engage their bodies and minds through fun and educational activities.
                            </p>
                        </div>
                        <div className='w-full md:w-[50%] flex justify-center md:justify-end mt-5 md:mt-0'>
                            <Parallax translateX={[35, -35]} className=''>
                                <img src={fox} alt="fox" className="w-[200px] h-[180px] md:w-[370px] md:h-[330px]" />
                            </Parallax>
                        </div>
                    </div>
                </div>
                <div className='wave rotate-180 -mt-16'>

                </div>
                <div className='flex flex-wrap '>
                    <div className="w-full md:w-[50%] flex justify-center md:justify-center p-4 ">
                        <div className="bg-[#0a3039]  md:h-[350px] md:w-[500px]  rounded-3xl relative">
                            <img
                                src={top}
                                alt="top"
                                className="absolute h-44 w-44 -top-32  right-40 "
                            />

                            <img
                                src={bottom}
                                alt="bottom"
                                className="absolute h-44 w-44 -bottom-[110px] right-40"
                            />

                            <Swiper
                                spaceBetween={20}
                                slidesPerView={1}
                                loop={true}
                                navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                }}
                                modules={[Navigation]}
                                className="w-[440px] mt-0.5 rounded-3xl"
                            >
                                {videoLinks.map((video, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="h-72 p-8 mt-8 w-[540px] mx-auto rounded-lgl relative flex items-center justify-center">
                                            <img
                                                src={video.thumbnail}
                                                alt={`Video Thumbnail ${index + 1}`}
                                                className="absolute inset-0 h-full w-full object-cover rounded-3xl"
                                            />
                                            <a
                                                href={video.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="absolute px-6 py-2 bg-[#16bab1] left-40 text-white rounded-lg z-10 transition hover:bg-[#c43b1e]"
                                            >
                                                Watch
                                            </a>
                                        </div>
                                    </SwiperSlide>
                                ))}

                            </Swiper>
                            <div className="swiper-button-prev text-white absolute left-[-30px] top-[50%] transform -translate-y-1/2 z-10 cursor-pointer"></div>
                            <div className="swiper-button-next text-white absolute right-[-30px] top-[50%] transform -translate-y-1/2 z-10 cursor-pointer"></div>
                        </div>
                    </div>
                    <div className="md:w-[40%] navbar-link p-4 md:mt-0 mt-6">
                        <div className="flex items-center space-x-2 mb-4">

                            <h1 className="text-[#0a3039] text-[#16bab1]xl md:text-[#16bab1]xl font-bold">About Us</h1>
                        </div>
                        <p className="text-[#000000] text-[18px] leading-relaxed md:text-justify text-[#16bab1]enter font-medium space-y-4">
                            At <span className="font-bold">Kalam Kids Kindergarten</span>, we believe every child is a spark of wonder waiting to shine.
                            Since 2016, we've been a loving second home for early learners in Vellore, founded by
                            <span className="font-bold"> Mr. S. Syed Kasim (VFX)</span> and led with care by
                            <span className="font-bold"> Mrs. Misbah Kasim (M.Sc., B.Ed.)</span>.
                            <br /><br />
                            Rooted in the values of <span className="font-bold">Dr. A.P.J. Abdul Kalam</span>, our school is a joyful space where learning
                            begins with love, laughter, and creativity. We offer
                            <span className="font-bold"> Day Care, Play Group, Pre-KG, LKG,</span> and <span className="font-bold">UKG</span> programs guided by passionate
                            educators who nurture curiosity, confidence, and kindness.
                            <br /><br />
                            With over <span className="font-bold">750 happy little graduates</span>, Kalam Kids is more than a school—it’s a family
                            where dreams take their first flight.
                        </p>
                    </div>

                </div>
                <div className='wave  mt-12'></div>
                <div className='bg-[#f4f1ea] navbar-link h-auto -mt-20 w-full'>
                    <div className='flex flex-wrap justify-center items-center max-w-screen-xl mx-auto'>
                        <div className='w-full lg:w-[50%]   mt-24 h-auto p-8'>
                            <h1 className='text-[#0a3039] text-[40px] lg:text-[60px] font-semibold'>Our mission</h1>
                            <p className='text-[#0a3039] text-base lg:text-xl w-full font-medium'>
                                Dream, dream, dream. Dreams transform into thoughts and thoughts result in action." – Dr. A.P.J. Abdul Kalam
                                Our mission is to nurture every child’s dream with gentle hands and open hearts.
                                We are committed to creating a space where children feel safe, loved, and inspired—a place where they can be curious, make mistakes, explore freely, and grow without fear.
                            </p>

                            <p className='text-[#0a3039] text-base lg:text-xl w-full pt-5 font-medium'>
                                With a balance of play and learning, we help build strong roots in values, imagination, and self-belief, guiding every child to bloom at their own beautiful pace.
                            </p>
                            {/* <button className="px-4 py-2 border border-[#16bab1] sensei-text mt-3 text-[#e84c24] rounded-md hover:bg-[#16bab1] hover:text-white transition">Learn More</button> */}
                        </div>
                        <div className='w-full lg:w-[50%] mt-24 lg:mt-24'>
                            <img src={man} alt="graduate" className='w-full h-96' />
                        </div>

                    </div>
                    <div>
                        <div className='flex flex-wrap justify-center items-center max-w-screen-xl mx-auto'>
                            <div className='w-full lg:w-[50%] mt-24 lg:mt-24'>
                                <img src={graduate} alt="community" className='w-[500px] h-[500px]' />
                            </div>
                            <div className='w-full lg:w-[50%]   mt-24 h-auto p-8'>
                                <h1 className='text-[#0a3039] text-[40px] lg:text-[60px] font-semibold'>Our Vision
                                </h1>
                                <p className='text-[#0a3039] text-base lg:text-xl w-full font-medium'>
                                    Great dreams of great dreamers are always transcended." – Dr. A.P.J. Abdul Kalam

                                    Our vision is to build a generation of confident, kind, and compassionate young learners who carry love in their hearts and dreams in their eyes.

                                    We strive to be a guiding light for families, a trusted place where your child is seen, heard, and celebrated for who they truly are.
                                    Through our programs and personal care, we aim to plant the seeds of lifelong learning, emotional strength, and positive character.
                                </p>
                                <p className='text-[#0a3039] text-base lg:text-xl w-full pt-5 font-medium'>
                                    At Kalam Kids, we don’t just teach—we treasure. We don’t just educate—we embrace. And we don’t just build students—we build little dreamers who will one day change the world.

                                </p>
                                {/* <button className="px-4 py-2 border border-[#16bab1] sensei-text mt-3 text-[#e84c24] rounded-md hover:bg-[#16bab1] hover:text-white transition">Learn More</button> */}
                            </div>

                        </div>
                        <div className='wave rotate-180 relative'>
                            <Parallax translateX={[-25, 25]} className='absolute  right-96 top-2'>
                                <img src={snail} alt="sanl" className=' rotate-180 ' />
                            </Parallax>
                        </div>
                    </div>
                </div>
            </div>
        </ParallaxProvider>
    )
}
export default AboutUs  